import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import './listaSATIFechada.css';
import { useTiposChamado } from '../../../hooks/useTiposChamado';

function formatarDataHoraBrasileira(dataHora) {
    const data = new Date(dataHora);
    return data.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
}

const TIPO_NOME_TO_COLOR = {
    'desenvolvimento': 'sati-fechada-badge--desenvolvimento',
    'erro em sistema': 'sati-fechada-badge--erro',
    'erro': 'sati-fechada-badge--erro',
    'nova funcionalidade': 'sati-fechada-badge--nova-func',
    'suporte geral': 'sati-fechada-badge--suporte',
    'problema de rede': 'sati-fechada-badge--rede',
    'rede': 'sati-fechada-badge--rede',
};

function getTipoBadgeClass(tipo, getNome) {
    const nome = (getNome ? getNome(tipo) : '') || '';
    const key = nome.trim().toLowerCase();
    const colorClass = TIPO_NOME_TO_COLOR[key] || TIPO_NOME_TO_COLOR[key?.replace(/\s+/g, ' ')];
    if (colorClass) return `sati-fechada-badge ${colorClass}`;
    const n = tipo != null ? Number(tipo) : 0;
    const idx = Math.abs(n) % 6;
    return `sati-fechada-badge sati-fechada-badge--${idx}`;
}

function ListaSATIFechada(props) {
    const history = useHistory();
    const { getNome } = useTiposChamado();
    const list = props.arraySATI || [];
    const sortBy = props.sortBy || 'date';
    const sortOrder = props.sortOrder || 'desc';
    const onSort = props.onSort;
    const technicianMap = props.technicianMap || {};
    const hasFilters = props.hasFilters === true;
    const showAssetColumn = list.some((s) => s.ativoRelacionado != null && String(s.ativoRelacionado).trim() !== '');

    const ThSort = ({ field, label }) => {
        const active = sortBy === field;
        const ariaSort = active ? (sortOrder === 'asc' ? 'ascending' : 'descending') : undefined;
        return (
            <th scope="col" className={onSort ? 'sati-fechada-th--sortable' : ''} aria-sort={ariaSort}>
                {onSort ? (
                    <button type="button" className="sati-fechada-th-btn" onClick={() => onSort(field)}>
                        {label}
                        {active && <i className={`fas fa-caret-${sortOrder === 'asc' ? 'up' : 'down'} sati-fechada-th-icon`} />}
                    </button>
                ) : (
                    label
                )}
            </th>
        );
    };

    const openDetail = (id, e) => {
        if (e?.target?.closest('a, button')) return;
        history.push(`/historicoSatiFechada/${id}`);
    };

    const emptyMessage = hasFilters
        ? 'Nenhum chamado encontrado para os filtros selecionados.'
        : 'Nenhum chamado encontrado.';

    const colCount = 7 + (showAssetColumn ? 1 : 0);

    return (
        <div className="sati-fechada-table-responsive">
            <table className="table table-modern align-middle sati-fechada-table">
                <thead>
                    <tr>
                        <ThSort field="number" label="Número" />
                        <th scope="col">Descrição</th>
                        <ThSort field="date" label="Data" />
                        <ThSort field="type" label="Tipo" />
                        <ThSort field="requester" label="Solicitante" />
                        <ThSort field="technician" label="Atendente" />
                        {showAssetColumn && <th scope="col" className="sati-fechada-col-ativo">Ativo</th>}
                        <th scope="col" className="sati-fechada-col-acao">Ver</th>
                    </tr>
                </thead>
                <tbody>
                    {list.length === 0 ? (
                        <tr>
                            <td colSpan={colCount} className="sati-fechada-empty">{emptyMessage}</td>
                        </tr>
                    ) : (
                        list.map((sati) => (
                            <tr key={sati.id} className="sati-fechada-row-clickable" onClick={(e) => openDetail(sati.id, e)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDetail(sati.id, e); } }}>
                                <td className="sati-fechada-num"><Link to={`/historicoSatiFechada/${sati.id}`} className="sati-fechada-num-link" onClick={(e) => e.stopPropagation()}>#{sati.id}</Link></td>
                                <td className="sati-fechada-desc" title={(sati.descricao || '').trim() || undefined}>{(sati.descricao || '').trim() || '—'}</td>
                                <td className="sati-fechada-date">{formatarDataHoraBrasileira(sati.data)}</td>
                                <td className="sati-fechada-cell-tipo"><span className={getTipoBadgeClass(sati.tipo, getNome)}>{getNome(sati.tipo)}</span></td>
                                <td>{sati.solicitante || '—'}</td>
                                <td>{technicianMap[String(sati.atendente)] ?? sati.atendente ?? '—'}</td>
                                {showAssetColumn && <td className="sati-fechada-col-ativo-cell">{sati.ativoRelacionado ? <span className="sati-fechada-ativo-badge">💻 {String(sati.ativoRelacionado).trim()}</span> : '—'}</td>}
                                <td onClick={(e) => e.stopPropagation()}>
                                    <Link to={`/historicoSatiFechada/${sati.id}`} className="btn btn-outline-primary btn-sm" title="Ver histórico do chamado"><i className="fas fa-eye" /></Link>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default ListaSATIFechada;
